import React from 'react';
import { Clock } from '../../utils';
import NonBreakingSpace from '../library/nbsp';
import { AuthorList, ChatAuthor, ChatMessage, DBMessage } from './use-chat-database';
import ScrollToBottom from 'react-scroll-to-bottom';
import { colorForViewerHash } from './utils';
import { ProfanityFilter } from './profanity';

export default function ChatMessages(props: {
  authorList: AuthorList;
  hasDatabase: boolean;
  messages: DBMessage[];
  showChatInput: boolean;
  viewerID: string;
  emptyState: React.ReactNode;
}) {
  const showMessage = (msg: DBMessage): boolean => {
    const messageViewerID = msg.val.vid;
    if (props.authorList[messageViewerID]?.hide) {
      if (messageViewerID == props.viewerID) {
        // Shadow ban -- viewers should see their own messages still
        return true;
      }
      return false;
    }
    return true;
  };

  const filteredMessages = props.messages.filter((msg) => showMessage(msg));
  return (
    <div
      className={`boxcast-chat--msgcontainer ${
        props.showChatInput ? '' : 'boxcast-chat--msgcontainer-no-input'
      }`}
    >
      {!props.hasDatabase && (
        <div>
          <ChatMessageBubbleSkeleton />
          <ChatMessageBubbleSkeleton />
          <ChatMessageBubbleSkeleton />
        </div>
      )}
      {!filteredMessages.length && props.hasDatabase && <>{props.emptyState}</>}
      {filteredMessages.length > 0 && props.hasDatabase && (
        <ScrollToBottom
          initialScrollBehavior={'auto'}
          className={`boxcast-chat--msgcontainer-messages${props.showChatInput ? '' : '-no-input'}`}
          followButtonClassName="boxcast-chat--to-bottom"
        >
          <ol>
            {filteredMessages.map((msg) => (
              <ChatMessageBubble
                key={msg.key}
                author={props.authorList[msg.val.vid]}
                {...msg.val}
              />
            ))}
          </ol>
        </ScrollToBottom>
      )}
    </div>
  );
}

const profanityFilter = new ProfanityFilter('');

function ChatMessageBubble(props: ChatMessage & { author: ChatAuthor }) {
  const messageTime = Clock.formatTime(Clock.parse(props.date));

  return (
    <div className="boxcast-chat--msg">
      <strong
        style={{
          color: colorForViewerHash(props.vid),
        }}
      >
        {props.author?.name || 'Anonymous'}
      </strong>
      {messageTime}
      {props.author?.mod ? ' | Chat Moderator' : ''}
      <span className="boxcast-chat--text">{profanityFilter.clean(props.text)}</span>
    </div>
  );
}

function ChatMessageBubbleSkeleton() {
  return (
    <div className="boxcast-chat--msg boxcast-chat--msg-loading-skeleton">
      <h3 style={{ width: '20%' }}>
        <NonBreakingSpace />
      </h3>
      <p style={{ width: '100%' }}>
        <NonBreakingSpace />
      </p>
      <p style={{ width: '25%' }}>
        <NonBreakingSpace />
      </p>
    </div>
  );
}
